<script>
import ApiErrorMixin from '@/mixins/apiErrorMixin'
import { formatDate } from '@/utils/date-util'
export default {
  name: 'OfficeStaffMixin',
  mixins: [ApiErrorMixin],
  data () {
    return {
      paginatorTotal: 0,
      loading: true,
      modelList: [],
      officeStaffFilterSet: {
        office: null,
        user: null,
        isPrioritized: null,
      },
    }
  },
  computed: {
  },
  methods: {
    getRequestParams () {
      const { user, office, isPrioritized } = this.officeStaffFilterSet

      const model = {
        isPrioritized,
        'office[id]': undefined,
        'user[id]': undefined,
      }

      if (user) {
        model['user[id]'] = user.id
      }
      if (office) {
        model['office[id]'] = office.id
      }

      return model
    },
    async requestList (page, size, setModelListCallback, setPaginationCallBack) {
      this.showPageLoader()
      try {
        this.loading = true
        this.modelList = []
        const params = {
          ...this.getRequestParams(),
          'page[number]': page || this.options.page,
          'page[size]': size || this.options.itemsPerPage
        }

        const response = await this.$store.dispatch(
          'organization/getOfficeStaffList',
          { params }
        )
        this.modelList = response.data.map((item) => ({
          ...item,
          dateString: formatDate(item.createdAt),
          isPrior: item.isPrioritized ? 'ДА' : 'НЕТ',
        }))

        if (response.headers['x-total-count']) {
          this.paginatorTotal = parseInt(response.headers['x-total-count'], 10)
        } else {
          this.paginatorTotal = this.footerProps.itemsPerPageOptions[1]
        }

        this.loading = false
        this.hidePageLoader()
      } catch (error) {
        console.log(error)
        this.loading = false
        this.hidePageLoader()
      }
    },
    async createBlackListEntry () {
      await this.proceedCreate(this.officeStaffFilterSet)
    },
    async proceedCreate (officeStaffFilterSet, saveCallback) {
      const { user, office } = officeStaffFilterSet

      const model = {
        'office': undefined,
        'user': undefined,
      }

      if (user) {
        model.laborer = { id: user }
      }
      if (office) {
        model.id = office
      }

      try {
        this.showPageLoader()
        await this.$store.dispatch(
          'organization/addOfficeMember',
          model
        )
        this.hidePageLoader()
        if (saveCallback) {
          saveCallback()
        }
        this.showSuccessNotification('Пользователь успешно добавлен в команду', 'success')
      } catch (error) {
        this.showErrorNotification('Ошибка при добавлении пользователя в команду', 'error')
        this.hidePageLoader()
      }
    },

    async submit () {
      const payload = {
        id: this.office.id,
        laborer: { id: this.laborer }
      }
      try {
        this.showPageLoader()
        this.loading = true
        await this.$store.dispatch(
          'organization/addOfficeMember',
          payload
        )
        // if (result.data && result.data.description && result.data.description.trim() !== '') {
        //   this.setDisplayNotifier(true)
        //   this.setNotifierMessage(` ${result.data.description.trim()}`)
        // }
        // await this.loadLogList(this.options.page, this.options.itemsPerPage)
        this.hidePageLoader()
        window.location.reload()
      } catch (error) {
        console.log(error)
        this.hidePageLoader()
      }
    },
    async removeMember (item, saveCallback) {
      try {
        this.showPageLoader()

        await this.$store.dispatch(
          'organization/removeOfficeMember',
          { id: item.id }
        )
        this.hidePageLoader()
        if (saveCallback) {
          saveCallback()
        }
        this.showSuccessNotification('Пользователь успешно удален из команды!', 'success')
      } catch (error) {
        console.log(error)
        this.hidePageLoader()
        this.showErrorNotification('Не удалось удалить пользователя из команды', 'error')
      }
    }
  }
}

</script>
